<template>
    <div
    id="Authenticate"
    class="bg-brand-secondary"
  >
    <!--TODO::Refactor this section -->
   
    <b-spinner class="brand-highlight-1" v-if="!showWarning"></b-spinner>
    <div class="d-flex flex-column justify-content-center text-center" v-else>
      <p class="error-message" v-html="warningMessage">
      </p>
      <b-button variant="cta-outline" class="mx-auto" squared size="lg" @click="back()">Back</b-button>
    </div>
  </div>
</template>

<script>
import OauthAdditionalDetails from "@/components/OauthAdditionalDetails.vue";
import * as Sentry from "@sentry/vue";

export default {
  name: "OAuthSimplyhealth",
  components: {OauthAdditionalDetails},
  data() {
      return {
        showWarning: false,
        warningMessage: 'Sorry, something went wrong, please try again!'
      };
  },
  mounted() {
      this.authenticate();
  },
  methods: {
    back(){
      history.back();
    },
    async authenticate() {
      let self = this;
      let payload = {
          code: this.getParameterFromURL("code"),
          scope: this.getParameterFromURL("scope"),
          code_verifier: sessionStorage.getItem("code_verifier_simplyhealth"),
          platform: "web",
      };

      let res = await this.$store.dispatch("authenticateWithProvider", {
          router: this.$router,
          payload,
          authType: 'simplyhealth'
      });
      Sentry.captureMessage('Sign In Succesful: ' + self.$store.getters.user.user.user_id);
      if(res.message?.includes('ineligible')){
        this.warningMessage = 'You are not eligible for this service<br><br>If you believe this is a mistake, please reach out to our customer support team <a class="link" href="https://www.simplyhealth.co.uk/contact-us/personal/online-form">here</a>. '
        this.showWarning = true;
      }
      if(res.message?.includes('invalid_grant')){
        this.$router.push("/login");
      }
      if (res === false || !res?.success) {
          this.showWarning = true;
      }
    },
    getParameterFromURL(paramName) {
        const params = new URLSearchParams(window.location.search);
        return params.get(paramName);
    }
  },

}
</script>
<style lang="less">
#Authenticate {
  position: relative;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  .link{
    font-family: "PlusJakartaSansRegular";
    color: white;
    text-decoration: underline;
  }
  .error-message{
    color: white;
    font-size: 2rem;
    padding: 20px;
  }
}
</style>
